module.exports = __webpack_public_path__ + "static/media/less.b0a91dc4.svg";